<template>
  <v-container pa-0 ma-0 fluid>
    <div class="section_inner">
      <v-row>
        <v-col class="pt-0">
          <h1 class="display-2 primary--text mt-0 mb-5">
            <v-icon color="primary--text" class="display-36 primary--text px-2">
              mdi-message-bulleted
            </v-icon>
            {{ content.pageTitle }}
          </h1>
          <DropDivider :width="'90%'" />
        </v-col>
      </v-row>

      <v-row class="px-3 contact-us-all" justify="space-between">
        <v-col cols="12" md="6">
          <h2 class="primary--text mb-5 h4">אז איך נוכל לעזור לך?</h2>
          <QuestionsAndAnswers />
        </v-col>

        <v-col cols="12" md="6" v-if="!formSubmited">
          <h2 class="primary--text h4" >{{ content.formTitle }}</h2>
          <v-form
            id="contact-us-form"
            ref="form"
            v-model="valid"
            class="rtl pa-0 mt-2"
            v-if="!formSent"
          >
            <v-row flex-row class="flex-column px-2">
              <v-col>
                <TextField
                  :fieldLabel="'שם'"
                  :fieldIconName="'mdi-account'"
                  @child-field="applyName"
                  v-model="nameField"
                />
                <TextField
                  :fieldLabel="'חברה'"
                  :fieldIconName="'mdi-domain'"
                  @child-field="applyCompanyName"
                  :fieldRequired="false"
                />
                <TextField
                  :fieldLabel="'נושא'"
                  :fieldIconName="'mdi-text-long'"
                  @child-field="applySubject"
                />

                <EmailField :editable="true" @newEmail="applyEmail" />
                <PhoneNumberField @updateNumber="applyPhone" />
                <TextAreaField
                  :fieldLabel="'תוכן הפניה'"
                  @child-field="applyMessage"
                />
                <v-col>
                  <v-btn
                    :disabled="!valid"
                    class="orange_btn_large"
                    @click="submitForm"
                  >
                    שלח
                  </v-btn>
                  <small
                    v-if="error"
                    class="d-block red--text text-center my-2"
                  >
                    שגיאה בשליחת הפנייה
                  </small>
                </v-col>
              </v-col>
            </v-row>
          </v-form>
          <v-alert border="top" color="primary" dark v-else>
            {{ content.sentText }}
          </v-alert>
        </v-col>
        <v-col v-else class="mt-3">
          <v-alert border="top" color="primary" dark>
            {{ content.sentLimitText }}
          </v-alert>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import TextField from '@/components/Forms/Form_Fields/TextField';
import PhoneNumberField from '@/components/Forms/Form_Fields/PhoneNumberField';
import EmailField from '@/components/Forms/Form_Fields/EmailField';
import TextAreaField from '@/components/Forms/Form_Fields/TextAreaField';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import DropDivider from '@/components/DropDownMenu/DropDivider';
import { CONTACT_US_SUBMIT } from '@/lib/api.js';
import QuestionsAndAnswers from '@/components/QuestionsAndAnswers/QuestionsAndAnswers';
import recaptchaV3 from '@/components/mixins/recaptchaV3';

export default {
  mixins: [recaptchaV3],
  components: {
    TextField,
    PhoneNumberField,
    EmailField,
    TextAreaField,
    DropDivider,
    QuestionsAndAnswers,
  },
  props: {
    formSubmited: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
      nameField: '',
      companyNameField: '',
      subjectField: '',
      emailField: '',
      phoneField: '',
      messageField: '',
      inProgress: false,
      lazy: false,
      dialog: false,
      error: false,
      content: t('titles.contactUs'),
      formSent: false,
    };
  },

  mounted() {
    this.$nuxt.$on('closeDialog', this.closeDialog);
  },

  beforeDestroy() {
    this.$nuxt.$off('closeDialog');
  },

  methods: {
    closeDialog(v) {
      this.dialog = v;
    },
    applyName(val) {
      this.nameField = val;
    },
    applyCompanyName(val) {
      this.companyNameField = val;
    },
    applySubject(val) {
      this.subjecField = val;
    },

    applyEmail(val) {
      this.emailField = val;
    },
    applyPhone(val) {
      this.phoneField = val;
    },
    applyMessage(val) {
      this.messageField = val.trim();
    },

    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async submitForm() {
      this.error = false;
      if (this.$refs.form.validate()) {
        const data = {
          Name: this.nameField,
          Company: this.companyNameField,
          Subject: this.subjecField,
          Email: this.emailField,
          Phone: this.phoneField,
          Details: this.messageField,
        };

        this.$nuxt.$loading.start();
        try {
          const recaptcha = await this.recaptchaCheck('contactUs');

          if (!recaptcha) {
            throw new Error('Recaptcha failed');
          }

          await this.$axios
            .post(`${CONTACT_US_SUBMIT}`, data)
            .then((response) => {
              if (response.data.IsError) {
                throw response.data.Error;
              }

              this.formSent = true;
              this.reset();
              this.$nuxt.$loading.finish();
            });
        } catch (e) {
          this.$nuxt.$loading.finish();

          this.error = true;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.divider > {
  width: 95%;
  margin: 0 auto;
}
</style>
